module.exports = __webpack_public_path__ + "static/3A841E_0_0-aaa57419540326134a484bc6c0ff1712.ttf";